import { render, staticRenderFns } from "./SaitenInputIchimai.vue?vue&type=template&id=0b634dfe&scoped=true&"
import script from "./SaitenInputIchimai.vue?vue&type=script&lang=ts&"
export * from "./SaitenInputIchimai.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenInputIchimai.vue?vue&type=style&index=0&id=0b634dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b634dfe",
  null
  
)

export default component.exports